import React from "react";
import ReactDOM from "react-dom";
import { useState } from 'react';
import "./css/index.css";
import "./css/title.scss";
import "./css/square.css";
import Button from "./components/Button";
import { ToggleButton } from "./components/ToggleButton";
//import ReusableToggleSwitch from "./components/ReusableToggleSwitch";

/*
Notes: {Enhancements}
-make play history optional (button?)
-make next player title more visible above board
-change restart button color match the rest of the theme
-add resizing to the whole page - mutildevice responsiveness compatibility
-adjust game board to center aligned
-move toggle button to left side
-add mutiplayer option?
-refactor code setup
*/


function Square(props, bgColor, hasCalled) {
  /* const [isEnterMouse, setIsEnterMouse] = useState(false);

  const handleBackground = state => {
    setIsEnterMouse(state);
  }; */
  
  const [bgColour, setBgColour] = useState("#efefef")

  if(hasCalled) {
    console.log(hasCalled, bgColor);
    setBgColour(bgColor);
  }

  const squareStyles = {
    background: {bgColour},
  };

  //console.log("squareStyles:", squareStyles);

  return (
    <button className="square" onClick={props.onClick} 
       /*  onMouseEnter={() => handleBackground(true)}
        onMouseLeave={() => handleBackground(false)}
        style={{background: isEnterMouse ? 'darkmagenta': ''}} */
        style={{background: bgColor ? squareStyles : ''}}
        >
      {props.value}
    </button>
  );
}

class Board extends React.Component {

  renderSquare(i) {
    return (
      <Square
        value={this.props.squares[i]}
        onClick={() => this.props.onClick(i)}
      />
    );
  }

  render() {

    return (
      <div className="tictactoe-board">
        <div className="board-row">
          {this.renderSquare(0)}
          {this.renderSquare(1)}
          {this.renderSquare(2)}
        </div>
        <div className="board-row">
          {this.renderSquare(3)}
          {this.renderSquare(4)}
          {this.renderSquare(5)}
        </div>
        <div className="board-row">
          {this.renderSquare(6)}
          {this.renderSquare(7)}
          {this.renderSquare(8)}
        </div>
      </div>
    );
  }
}

class Game extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      history: [
        {
          squares: Array(9).fill(null),
        },
      ],
      stepNumber: 0,
      xIsNext: true,
      selected: localStorage.getItem("selectedGameMode") != null ? JSON.parse(localStorage.getItem("selectedGameMode")) : true,
      showGameHistory: localStorage.getItem("showGameHistory") != null ? JSON.parse(localStorage.getItem("showGameHistory")) : true,
    };

    if(localStorage.getItem("selectedGameMode") === null) {
      localStorage.setItem('selectedGameMode', this.state.selected);
    }

    if(localStorage.getItem("showGameHistory") === null) {
      localStorage.setItem('showGameHistory', this.state.showGameHistory);
    }
  }

  componentDidMount() {
    document.title = "Tic-Tac-Toe Game"; 
  }

  //handleClick has an argument 'i' which corresponds with the specific square it was called from
  makeNextMove(i) {
    //Using [Row,Col] setup for locations
    const locations = [
      [1, 1],
      [1, 2],
      [1, 3],
      [2, 1],
      [2, 2],
      [2, 3],
      [3, 1],
      [3, 2],
      [3, 3]
    ];

    const history = this.state.history.slice(0, this.state.stepNumber + 1);
    const current = history[history.length - 1];
    const squares = current.squares.slice();
    if (calculateWinner(squares) || squares[i]) {
      return;
    }
    squares[i] = this.state.xIsNext ? "X" : "O";
    this.setState({
      history: history.concat([
        {
          squares: squares,
          location: locations[i],
          value: squares[i]
        },
      ]),
      stepNumber: history.length,
      xIsNext: !this.state.xIsNext,
    });
  }

  async handleClick(i) {
    console.log("selectedGameMode",this.state.selected);

    // Apply player move to square i
    await this.makeNextMove(i);

    if(this.state.selected) {
      // Pauses for 500ms before AI plays next move
      await addNSecondsDelay(0.5);

      // Apply AI move after
      const squares = this.state.history[this.state.stepNumber].squares.slice();
      const bestSquare = this.findBestSquare(squares, this.state.xIsNext ? "X" : "O");
      if (bestSquare !== -1) {
        await this.makeNextMove(bestSquare); 
      }
    }
  }

  isBoardFilled(squares) {
    for (let i = 0; i < squares.length; i++) {
      if (squares[i] === null) {
        return false;
      }
    }
    return true;
  }
  
  findBestSquare(squares, player) {
    // 'player' is the maximizing player
    // 'opponent' is the minimizing player
    const opponent = player === 'X' ? 'O' : 'X';
    
    const minimax = (squares, isMax) => {
      const winner = calculateWinner(squares);
      
      // If player wins, score is +1
      if (winner === player) return { square: -1, score: 1 };
      
      // If opponent wins, score is -1
      if (winner === opponent) return { square: -1, score: -1 };
      
      // If Tie, score is 0
      if (this.isBoardFilled(squares)) return { square: -1, score: 0 };
      
      // Initialize 'best'. If isMax, we want to maximize score, and minimize otherwise.
      const best = { square: -1, score: isMax ? -1000 : 1000 };
      
      // Loop through every square on the board
      for (let i = 0; i < squares.length; i++) {
        // If square is already filled, it's not a valid move so skip it
        if (squares[i]) {
          continue;
        }
        
        // If square is unfilled, then it's a valid move. Play the square.
        squares[i] = isMax ? player : opponent;
        // Simulate the game until the end game and get the score,
        // by recursively calling minimax.
        const score = minimax(squares, !isMax).score;
        // Undo the move
        squares[i] = null;
  
        if (isMax) {
          // Maximizing player; track the largest score and move.
          if (score > best.score) {
            best.score = score;
            best.square = i;
          }
        } else {
          // Minimizing opponent; track the smallest score and move.
          if (score < best.score) {
            best.score = score;
            best.square = i;
          }
        }
      }
      
      // The move that leads to the best score at end game.
      return best;
    };
    
    // The best move for the 'player' given current board
    return minimax(squares, true).square;
  }

  jumpTo(step) {
    //console.log("jumpTo-step:: ",step);
    this.setState({
      stepNumber: step,
      xIsNext: step % 2 === 0,
    });
  }
  
  handleBackground(hasMouseEntered, state, moveRow, moveCol) {
    hasMouseEntered = state;

    if(hasMouseEntered){
      Square(this.state, "darkmagenta", true)
    }

    console.log("test", hasMouseEntered, moveRow, moveCol);
  };

  // Allows player to select to play either against local co-op player or AI
  toggleSelected = newValue => {
    const newSelectedVal = JSON.parse(localStorage.getItem("selectedGameMode"));
    localStorage.setItem("selectedGameMode",!newSelectedVal);
    this.setState({ selected: !newSelectedVal });
  }

  showHideGameHistory = () => {
    const newGameHistoryVal = JSON.parse(localStorage.getItem("showGameHistory"));
    localStorage.setItem('showGameHistory', !newGameHistoryVal);
    this.setState({ showGameHistory: !newGameHistoryVal });
  }

  render() {
    const history = this.state.history;
    //Retrieves move history at a particular move
    const current = history[this.state.stepNumber];
    const winner = calculateWinner(current.squares);

    //console.log("history:: ",history);
    //console.log("current:: ",current,"stepNumber::",this.state.stepNumber);

    const moves = history.map((step, move) => {
      //console.log("step:: ",(step.location)-1);

      const desc = move 
        ? "Go to move #" + move + " @ Row:" + history[move].location[0] + ", Col:" + history[move].location[1] + " with value: " + history[move].value 
        : "Go to game start";

      //console.log("move:: ",move);

      //const [isEnterMouse, setIsEnterMouse] = useState(false);
      //const hasMouseEntered = false;

      return (
        <li key={move}>
          {/* <button onClick={() => this.jumpTo(move)}
            onMouseEnter={() => handleBackground(true)}
            onMouseLeave={() => handleBackground(false)}
            style={{background: isEnterMouse ? 'darkmagenta': ''}}
          ></button> */}
          {/* <button onClick={() => this.jumpTo(move)}
            onMouseEnter={() => this.handleBackground(hasMouseEntered, true, move !== 0 ? history[move].location[0] : 0, move !== 0 ? history[move].location[1] : 0)}
            onMouseLeave={() => this.handleBackground(hasMouseEntered, false)}
            style={{background: hasMouseEntered ? 'darkmagenta': ''}}
          > */}
            {/* if current move equals the last move in history list then bold it */}
            {/* {move === this.state.stepNumber ? <b>{desc}</b> : desc}
          </button> */}

          <Button type="outline" btnColor="#862d98" btnBgColor="#fae0ff" btnFontColor="black" onClick={() => this.jumpTo(move)}>
            {move === this.state.stepNumber ? <b>{desc}</b> : desc}
          </Button>
        </li>
      );
    });

    let status;
    let title;
    if (winner) {
      title = "Game Over - ";
      status = "Winner: " + winner;
    } else if (!current.squares.includes(null)) { //If not empty squares and no winner - then draw
      title = "Game Over - ";
      status = "Draw";
    } else {
      title = "Next player: ";
      status = (this.state.xIsNext ? "X" : "O");
    }

    return (
      <div className="game-app">

        <div className="title-container">
          <h1>Tic-Tac-Toe</h1>
        </div>
        
        <div className="game-options-container">
          <div className="game-options">
            <p className="option-text">VS. AI or Player?</p>
            <div className="option">
              <ToggleButton selected={this.state.selected} toggleSelected={this.toggleSelected}/>
            </div>
          </div>

          <div className="game-options">
            <p className="option-text">Toggle Play History</p>
            <div className="option">
              <div className="toggle-container" onClick={this.showHideGameHistory}>
                <div className={`dialog-button ${this.state.showGameHistory ? "disabled": ""}`}>
                  {this.state.showGameHistory ? "Hide" : "Show"}
                </div>
              </div>
            </div>
            {/* <div className="option">
              <ReusableToggleSwitch id={"gameHistoryToggle"} onClick={() => this.showHideGameHistory()} toggleState={this.state.showGameHistory} toggleTrueText={"Show"} toggleFalseText={"Hide"} />
            </div> */}
          </div>
        </div>
        
        <div className="game-container">
          <div className="game-board">
            <div className="play-status">{title} <span className="play-status-move">{status}</span></div>
            <Board squares={current.squares} onClick={(i) => this.handleClick(i)}/>
            <p>
              <Button type="outline" btnColor="#47206b" btnBgColor="#7cc6e4" onClick={() => window.location.reload(false)}>Click to reload page & Restart game!</Button>
            </p>
          </div>

          { this.state.showGameHistory ?
            <div className="game-info">
              <div className="play-status">Move History</div>
              <ol className="player-moves">{moves}</ol>
            </div>
            : null
          }
        </div>
      </div>
    );
  }
}

// Delay next action by n ms
const addNSecondsDelay = (n) => {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve();
    }, n * 1000);
  });
}

function calculateWinner(squares) {
  const lines = [
    [0, 1, 2],
    [3, 4, 5],
    [6, 7, 8],
    [0, 3, 6],
    [1, 4, 7],
    [2, 5, 8],
    [0, 4, 8],
    [2, 4, 6],
  ];
  for (let i = 0; i < lines.length; i++) {
    const [a, b, c] = lines[i];
    if (squares[a] && squares[a] === squares[b] && squares[a] === squares[c]) {
      return squares[a];
    }
  }
  return null;
}

// ========================================

ReactDOM.render(<Game />, document.getElementById("root"));
